import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={22} fill="currentColor" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.085 1.012c0-.559.463-1.012 1.034-1.012h5.762c.571 0 1.034.453 1.034 1.012 0 .56-.463 1.012-1.034 1.012h-1.847v2.209h1.847c2.185 0 4.28.85 5.825 2.363a7.984 7.984 0 0 1 2.413 5.704v4.233c0 .559-.463 1.012-1.034 1.012H3.915c-.57 0-1.034-.453-1.034-1.012V12.3c0-2.14.868-4.192 2.413-5.704a8.326 8.326 0 0 1 5.825-2.363h1.847V2.024H11.12c-.571 0-1.034-.453-1.034-1.012Zm1.034 5.245a6.237 6.237 0 0 0-4.363 1.77A5.98 5.98 0 0 0 4.949 12.3v3.22H23.05V12.3a5.98 5.98 0 0 0-1.807-4.273 6.237 6.237 0 0 0-4.363-1.77H11.12ZM0 20.766c0-.56.463-1.013 1.034-1.013h25.932c.571 0 1.034.453 1.034 1.013 0 .559-.463 1.012-1.034 1.012H1.034C.463 21.778 0 21.325 0 20.766Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
